import { render, staticRenderFns } from "./surface_nav.vue?vue&type=template&id=231c2b85&scoped=true&"
import script from "./surface_nav.vue?vue&type=script&lang=js&"
export * from "./surface_nav.vue?vue&type=script&lang=js&"
import style0 from "./surface_nav.vue?vue&type=style&index=0&id=231c2b85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231c2b85",
  null
  
)

export default component.exports